import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appAppDetectOutsideClick]',
    standalone: false,
})
export class AppDetectOutsideClickDirective {
    @Output() appAppDetectOutsideClick = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) {}

    @HostListener('document:click', ['$event.target'])
    public onClick(target) {
        const clickedInside =
            this.elementRef.nativeElement.contains(target) ||
            target.innerText === 'Filters' ||
            target.classList.contains('searchFilters') ||
            target.classList.contains('addToIgnoreList') ||
            target.innerText === 'Search' ||
            target.textContent === 'Searchclose';
        const timePickerConintainers = document.getElementsByClassName('timepicker-backdrop-overlay');
        let timePickerFound = false;
        if (timePickerConintainers?.length > 0) {
            timePickerFound = true;
        }
        const avoidedElements = [
            'cdk-overlay-backdrop',
            'cdk-overlay-pane',
            'mat-mdc-option',
            'mdc-list-item',
            'mdc-list-item__primary-text',
            'mat-mdc-select-panel',
            'mat-mdc-select-trigger',
            'mat-option-text',
            'mat-option-multiple',
            'mat-optgroup-label',
            'mat-mdc-checkbox',
            'mdc-checkbox',
            'mat-pseudo-checkbox',
            'mat-mdc-button',
            'mat-mdc-icon-button',
            'mdc-button__label',
            'mat-ripple',
            'mat-focus-indicator',
            'mdc-ripple-surface',
            'mat-datepicker-content',
            'mat-mdc-datepicker-content',
            'mat-calendar-body-cell-content',
            'mat-calendar-period-button',
            'mat-calendar-previous-button',
            'mat-calendar-next-button',
            'mat-calendar-arrow',
            'mat-calendar-controls',
            'mat-calendar-header',
            'mat-calendar-body-label',
            'mat-calendar-table-header',
            'mat-calendar-table',
            'notranslate',
            'deleteSaveFilter',
            'editSaveFilter',
            'highlightSuggestedOption',
            'addToIgnoreList',
            'q-right-align',
            'timepicker__main-content',
            'clock-face',
            'clock-face__container',
            'clock-face__number',
            'timepicker__actions',
            'timepicker-button',
        ]; /* elements class name that needs to be avoided when clicked on it */
        let elementFound: boolean;
        for (const avoidedElement of avoidedElements) {
            if (
                target?.classList?.contains(avoidedElement) ||
                target?.parentNode?.classList?.contains(avoidedElement) ||
                target?.parentElement?.classList?.contains(avoidedElement) ||
                target?.parentElement?.parentElement?.classList?.contains(avoidedElement) ||
                target?.parentElement?.parentElement?.parentElement?.classList?.contains(avoidedElement) ||
                target?.id?.includes('mat-calendar-button-')
            ) {
                elementFound = true;
                break;
            } else {
                elementFound = false;
            }
        }
        if (!clickedInside && !elementFound && !timePickerFound) {
            this.appAppDetectOutsideClick.emit();
        }
    }
}
